import { useCallback, useEffect, useRef } from 'react';

// some components from 3-rd party libraries don't update callback on rerender
// this utility hook fixes the issue
export function useRefWrappedCallback<T extends (...args: never[]) => unknown>(
  callback: T
) {
  // create a ref to wrap the callback
  const callbackWrapperRef = useRef(callback);

  // update the callback on rerender
  useEffect(() => {
    callbackWrapperRef.current = callback;
  });

  // create and return a referentially stable callback
  return useCallback((...args: Parameters<T>) => {
    // call the wrapped callback
    return callbackWrapperRef.current(...args) as ReturnType<T>;
  }, []);
}
